import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DocumentService {

  constructor(public http:HttpClient) { }

  uploadDoc(data){
    //console.log(data)
    return this.http.post(environment.api_link+"/api/document/upload_files",data)
  }

  getDocumentList(){
    return this.http.post(environment.api_link+"/api/document/lists",{})
  }

  getDocumentImage(id){
    return this.http.get(`${environment.api_link}/api/document/show_image/${id}`)
  }
}
